import { flatten } from 'lodash';
import { TaskWorkspaceState } from '../../../h3ml/state/task-workspace-state';
import { AnnotationOperation } from '../../../shared/resources/annotation-resource.service';

interface OperationBuilder {
  canBuild(): boolean;
  build(): AnnotationOperation;
}

export abstract class AbstractChangeOperationService<EntryType> {
  getOperations(previous: TaskWorkspaceState, current: TaskWorkspaceState) {
    const entries = this.getEntries(previous, current);
    const builders = flatten(
      entries.map((entry) => this.createBuilders(entry)),
    );
    return builders
      .filter((builder) => builder.canBuild())
      .map((builder) => builder.build());
  }

  protected abstract getEntries(
    previous: TaskWorkspaceState,
    current: TaskWorkspaceState,
  ): EntryType[];

  protected abstract createBuilders(entry: EntryType): OperationBuilder[];
}
